import {Typography} from '@mui/material';
import {PlannerDate} from '../planner-item';

export type PlannerListDateItemProps = {
  date: PlannerDate;
  style?: React.CSSProperties;
};

export const plannerListSectionHeaderSx = {
  fontWeight: '500',
  fontSize: '21px',
  color: 'primary.main',
  bgcolor: 'blue.bg',
  paddingY: '9.5px',
  paddingX: '4px',
} as const;

export function PlannerListDateItem({date, ...rest}: PlannerListDateItemProps) {
  return (
    <Typography sx={plannerListSectionHeaderSx} {...rest}>
      {date.format.dayOfWeek}, {date.format.day}
    </Typography>
  );
}
